/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { ApiResponseOfString } from '../models/api-response-of-string';
import { ArchiveTemplate } from '../models/archive-template';
import { DataPageOfPatientArchive } from '../models/data-page-of-patient-archive';
import { DataPageOfPatientPurge } from '../models/data-page-of-patient-purge';
import { patientArchiveGet } from '../fn/patient-archive/patient-archive-get';
import { PatientArchiveGet$Params } from '../fn/patient-archive/patient-archive-get';
import { patientArchiveGetArchiveTemplate } from '../fn/patient-archive/patient-archive-get-archive-template';
import { PatientArchiveGetArchiveTemplate$Params } from '../fn/patient-archive/patient-archive-get-archive-template';
import { patientArchiveGetClinicalArchiveTemplates } from '../fn/patient-archive/patient-archive-get-clinical-archive-templates';
import { PatientArchiveGetClinicalArchiveTemplates$Params } from '../fn/patient-archive/patient-archive-get-clinical-archive-templates';
import { patientArchivePatientPurgeSearch } from '../fn/patient-archive/patient-archive-patient-purge-search';
import { PatientArchivePatientPurgeSearch$Params } from '../fn/patient-archive/patient-archive-patient-purge-search';
import { patientArchivePatientPurgeUpdate } from '../fn/patient-archive/patient-archive-patient-purge-update';
import { PatientArchivePatientPurgeUpdate$Params } from '../fn/patient-archive/patient-archive-patient-purge-update';
import { patientArchivePost } from '../fn/patient-archive/patient-archive-post';
import { PatientArchivePost$Params } from '../fn/patient-archive/patient-archive-post';
import { patientArchiveRestore } from '../fn/patient-archive/patient-archive-restore';
import { PatientArchiveRestore$Params } from '../fn/patient-archive/patient-archive-restore';
import { patientArchiveSearch } from '../fn/patient-archive/patient-archive-search';
import { PatientArchiveSearch$Params } from '../fn/patient-archive/patient-archive-search';
import { PatientArchiveSettings } from '../models/patient-archive-settings';

@Injectable({ providedIn: 'root' })
export class PatientArchiveService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `patientArchiveGetClinicalArchiveTemplates()` */
  static readonly PatientArchiveGetClinicalArchiveTemplatesPath = '/api/PatientArchive/patientarchive/archiveClinicalTemplates';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchiveGetClinicalArchiveTemplates()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGetClinicalArchiveTemplates$Response(params?: PatientArchiveGetClinicalArchiveTemplates$Params, context?: HttpContext): Observable<StrictHttpResponse<ArchiveTemplate>> {
    return patientArchiveGetClinicalArchiveTemplates(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchiveGetClinicalArchiveTemplates$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGetClinicalArchiveTemplates(params?: PatientArchiveGetClinicalArchiveTemplates$Params, context?: HttpContext): Observable<ArchiveTemplate> {
    return this.patientArchiveGetClinicalArchiveTemplates$Response(params, context).pipe(
      map((r: StrictHttpResponse<ArchiveTemplate>): ArchiveTemplate => r.body)
    );
  }

  /** Path part for operation `patientArchiveGet()` */
  static readonly PatientArchiveGetPath = '/api/PatientArchive/patientarchive/getsettings';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchiveGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGet$Response(params?: PatientArchiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<PatientArchiveSettings>> {
    return patientArchiveGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchiveGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGet(params?: PatientArchiveGet$Params, context?: HttpContext): Observable<PatientArchiveSettings> {
    return this.patientArchiveGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<PatientArchiveSettings>): PatientArchiveSettings => r.body)
    );
  }

  /** Path part for operation `patientArchivePost()` */
  static readonly PatientArchivePostPath = '/api/PatientArchive/patientarchive/upsert';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchivePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientArchivePost$Response(params: PatientArchivePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return patientArchivePost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchivePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patientArchivePost(params: PatientArchivePost$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.patientArchivePost$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

  /** Path part for operation `patientArchiveSearch()` */
  static readonly PatientArchiveSearchPath = '/api/PatientArchive/patientarchive/Search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchiveSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveSearch$Response(params?: PatientArchiveSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatientArchive>> {
    return patientArchiveSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchiveSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveSearch(params?: PatientArchiveSearch$Params, context?: HttpContext): Observable<DataPageOfPatientArchive> {
    return this.patientArchiveSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfPatientArchive>): DataPageOfPatientArchive => r.body)
    );
  }

  /** Path part for operation `patientArchiveRestore()` */
  static readonly PatientArchiveRestorePath = '/api/PatientArchive/patientarchive/restore';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchiveRestore()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveRestore$Response(params?: PatientArchiveRestore$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return patientArchiveRestore(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchiveRestore$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveRestore(params?: PatientArchiveRestore$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.patientArchiveRestore$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

  /** Path part for operation `patientArchiveGetArchiveTemplate()` */
  static readonly PatientArchiveGetArchiveTemplatePath = '/api/PatientArchive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchiveGetArchiveTemplate()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGetArchiveTemplate$Response(params?: PatientArchiveGetArchiveTemplate$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArchiveTemplate>>> {
    return patientArchiveGetArchiveTemplate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchiveGetArchiveTemplate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchiveGetArchiveTemplate(params?: PatientArchiveGetArchiveTemplate$Params, context?: HttpContext): Observable<Array<ArchiveTemplate>> {
    return this.patientArchiveGetArchiveTemplate$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ArchiveTemplate>>): Array<ArchiveTemplate> => r.body)
    );
  }

  /** Path part for operation `patientArchivePatientPurgeSearch()` */
  static readonly PatientArchivePatientPurgeSearchPath = '/api/PatientArchive/patientarchive/patientPurgeSearch';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchivePatientPurgeSearch()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchivePatientPurgeSearch$Response(params?: PatientArchivePatientPurgeSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<DataPageOfPatientPurge>> {
    return patientArchivePatientPurgeSearch(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchivePatientPurgeSearch$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchivePatientPurgeSearch(params?: PatientArchivePatientPurgeSearch$Params, context?: HttpContext): Observable<DataPageOfPatientPurge> {
    return this.patientArchivePatientPurgeSearch$Response(params, context).pipe(
      map((r: StrictHttpResponse<DataPageOfPatientPurge>): DataPageOfPatientPurge => r.body)
    );
  }

  /** Path part for operation `patientArchivePatientPurgeUpdate()` */
  static readonly PatientArchivePatientPurgeUpdatePath = '/api/PatientArchive/patientarchive/patientPurgeUpdate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patientArchivePatientPurgeUpdate()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchivePatientPurgeUpdate$Response(params?: PatientArchivePatientPurgeUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseOfString>> {
    return patientArchivePatientPurgeUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patientArchivePatientPurgeUpdate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  patientArchivePatientPurgeUpdate(params?: PatientArchivePatientPurgeUpdate$Params, context?: HttpContext): Observable<ApiResponseOfString> {
    return this.patientArchivePatientPurgeUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<ApiResponseOfString>): ApiResponseOfString => r.body)
    );
  }

}
